import React from "react";
import { useLocation } from "react-router";
import ReactDOM from "react-dom/client";
import {
  useSearchParams,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Root from "./routes/Root";
import ErrorPage from "./error-page";
import Maintenance from "./routes/Maintenance";
import ThankYou from "./routes/ThankYou";
import MessageSent from "./routes/MessageSent";
import About from "./routes/About";
import Paintings from "./routes/Paintings";
import PaintingDetails from "./routes/Painting-Details";
import ShoppingCart from "./routes/Shopping-Cart";
//import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import Checkout from "./routes/Checkout";
import LogIn from "./routes/LogIn";
import LogOut from "./routes/LogOut";
import Shipping from "./routes/Shipping";
import AddShipping from "./routes/AddShipping";
import AddPainting from "./routes/AddPainting";
import AddSize from "./routes/AddSize";
import Sizes from "./routes/Sizes";
import AddPrint from "./routes/AddPrint";
import Prints from "./routes/Prints";
import Contact from "./routes/Contact";
import { Footer } from "./components/Footer";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "maintenance",
        element: <Maintenance Title="Maintenance" />,
      },
      {
        path: "thankyou",
        element: <ThankYou Title="Thank You" />,
      },
      {
        path: "messagesent",
        element: <MessageSent Title="Message" />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "paintings/:Params",
        element: <Paintings Params={{}} Title="Paintings" MaxRows={6} />,
      },
      {
        path: "paintingdetails/:Params",
        element: <PaintingDetails Params={{}} Title="Painting Details" />,
      },
      {
        path: "addpainting",
        element: <AddPainting Title="Add Painting" />,
      },
      {
        path: "shoppingcart/:Params",
        element: <ShoppingCart Params={{}} Title="Shopping Cart" />,
      },
      {
        path: "checkout",
        element: <Checkout Title="Checkout" />,
      },
      {
        path: "login",
        element: <LogIn />,
      },
      {
        path: "logout",
        element: <LogOut />,
      },
      {
        path: "addshipping",
        element: <AddShipping Title="Add Shipping" />,
      },
      {
        path: "shipping",
        element: <Shipping Title="Shipping" />,
      },
      {
        path: "addsize",
        element: <AddSize Title="Add Size" />,
      },
      {
        path: "sizes",
        element: <Sizes Title="Sizes" />,
      },
      {
        path: "addprint",
        element: <AddPrint Title="Add Print Details" />,
      },
      {
        path: "prints",
        element: <Prints Title="Prints" />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <RouterProvider router={router} />
    <Footer />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
